import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ThemeProvider } from '@emotion/react';
import { theme } from './Theme/theme';
import AppWrapper from './AppWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
           <AppWrapper />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// Service Worker handling
if ('serviceWorker' in navigator) {
  const isProduction = process.env.REACT_APP_ENABLE_SW === 'true';

  if (!isProduction) {
    // DEV MODE: unregister SW + clear cache
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
  } else {
    // PROD MODE: register SW
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered');

          // Listen once for controller change
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('New version activated, reloading...');
            window.location.reload();
          });

          // Detect new SW
          registration.onupdatefound = () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.onstatechange = () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                console.log('New version available, skipping waiting...');
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            };
          };
        })
        .catch((error) => {
          console.error('SW registration failed:', error);
        });
    });
  }
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
